/* ==========================================================================
  main.js
========================================================================== */

'use strict';

import "./_modules"; // this pulls in generated _modules.js

import "./lib/blocks";
//import "./lib/carousels";

import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
  const swiperEl = document.querySelector('.theme-image-carousel .swiper');

  const swiper = new Swiper(swiperEl, {
    modules: [Navigation],
    navigation: {
      addIcons: false,
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    loop: true,
    slidesPerView: 'auto',
  });
});


/**
 * Init responsive videos
 */
//fitvids();

/**
 * Init CSS vars ponyfill 
 */
//cssVars({});

 
/**
 * Top padding for the content because we have a fixed header
 */
/*
const siteHeader = document.querySelector('.site-header');
const siteBody = document.querySelector('.site-content');
//const mobileNav = document.querySelector('.mobile-menu__nav');
let siteHeaderHeight;

document.addEventListener('DOMContentLoaded', () => {
  siteHeaderHeight = siteHeader.offsetHeight;
  siteBody.style.paddingTop = `${siteHeaderHeight}px`;
  //mobileNav.style.paddingTop = `${siteHeaderHeight}px`;
});

addEventListener('resize', (event) => {
  siteHeaderHeight = siteHeader.offsetHeight;
  siteBody.style.paddingTop = `${siteHeaderHeight}px`;
  //mobileNav.style.paddingTop = `${siteHeaderHeight}px`;
});


// snippet that will find all elements with the class screenreaderhidden and add aria-hidden="true"
document.querySelectorAll('.screenreaderhidden').forEach(el => {
  el.setAttribute('aria-hidden', 'true');
});
*/

/**
 * Animate numbers from 0 to ...
 */
document.addEventListener("DOMContentLoaded", () => {
  const elements = document.querySelectorAll(".key-figures-num");

  const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

  function formatOriginal(value, decimals, separator) {
    let str = value.toFixed(decimals);
    if (separator === ",") {
      str = str.replace(".", ","); // replace decimal dot with comma
    }
    if (decimals === 0) {
      str = Math.floor(value).toString(); // integer-only if original had no decimals
    }
    return str;
  }

  function animateValue(el, start, end, duration, decimals, separator, suffix = "") {
    const startTime = performance.now();

    function update(time) {
      const progress = Math.min((time - startTime) / duration, 1);
      const current = start + (end - start) * easeOutCubic(progress);

      el.textContent = formatOriginal(current, decimals, separator) + suffix;

      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        el.textContent = formatOriginal(end, decimals, separator) + suffix;
      }
    }

    requestAnimationFrame(update);
  }

  elements.forEach((el) => {
    const text = el.textContent.trim();
    const match = text.match(/^([\d.,]+)\s*(.*)$/);

    if (!match) return;

    const numberText = match[1];
    const suffix = match[2] || "";

    const hasComma = numberText.includes(",");
    const hasDot = numberText.includes(".");
    let separator = "";
    let decimals = 0;

    if (hasComma && !hasDot) {
      separator = ",";
      const parts = numberText.split(",");
      decimals = parts[1] ? parts[1].length : 0;
    } else if (hasDot && !hasComma) {
      separator = ".";
      const parts = numberText.split(".");
      decimals = parts[1] ? parts[1].length : 0;
    }

    let numericValue = numberText.replace(/[^\d.,]/g, "");
    numericValue = numericValue.replace(/\./g, "").replace(",", ".");

    const targetNumber = parseFloat(numericValue);

    const duration = Math.min(2000, Math.max(600, targetNumber * 300));

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animateValue(el, 0, targetNumber, duration, decimals, separator, suffix);
          obs.unobserve(el);
        }
      });
    }, { threshold: 0.3 });

    observer.observe(el);
  });
});
